import { SIDE_PANEL_CONTENTS } from "../types.js";
import { useLocalStorage } from "../../../hooks/useLocalStorage.js";
import { AuthViewModel } from "../../AuthWrapper2/viewmodels/AuthViewModel.js";
import { ViewModel, singleton } from "mvc-kit";
// src/modules/AppWrapper2/viewmodels/SidePanelViewModel.ts
function isSidePanelContent(value) {
	return SIDE_PANEL_CONTENTS.includes(value);
}
var SidePanelViewModel = class SidePanelViewModel extends ViewModel {
	static DEFAULT_STATE = {
		content: "organization",
		isOpen: false,
		isPinned: false
	};
	get hasUnreadMail() {
		return !!singleton(AuthViewModel).state.identityInfo?.user?.userClientMetadata?.unread?.mail;
	}
	onInit() {
		this.subscribeTo(singleton(AuthViewModel), () => {});
		this.loadPersistedState();
	}
	onSet(prev, next) {
		const userId = singleton(AuthViewModel).currentUser?.id;
		if (!userId) return;
		if (prev.isOpen !== next.isOpen) useLocalStorage.setItem(`side_panel_was_open_${userId}`, next.isOpen);
		if (prev.isPinned !== next.isPinned) useLocalStorage.setItem(`side_panel_pinned_${userId}`, next.isPinned);
		if (prev.content !== next.content) useLocalStorage.setItem(`side_panel_content_${userId}`, next.content);
	}
	open() {
		this.set({ isOpen: true });
	}
	close() {
		this.set({ isOpen: false });
	}
	pin() {
		this.set({ isPinned: true });
	}
	unPin() {
		this.set({ isPinned: false });
	}
	openTo(content) {
		this.set({
			content,
			isOpen: true
		});
	}
	setContent(content) {
		this.set({ content });
	}
	loadPersistedState() {
		const userId = singleton(AuthViewModel).currentUser?.id;
		if (!userId) return;
		const isPinned = useLocalStorage.getItem(`side_panel_pinned_${userId}`) ?? false;
		const wasOpen = useLocalStorage.getItem(`side_panel_was_open_${userId}`) ?? false;
		const storedContent = useLocalStorage.getItem(`side_panel_content_${userId}`);
		const content = isSidePanelContent(storedContent) ? storedContent : SidePanelViewModel.DEFAULT_STATE.content;
		this.set({
			content,
			isOpen: wasOpen && isPinned,
			isPinned
		});
	}
};
export { SidePanelViewModel };

//# sourceMappingURL=SidePanelViewModel.js.map